module.exports = __webpack_public_path__ + "static/img/memberBn.16a1558.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/common/memberBn.jpg
// module id = XExn
// module chunks = 1